import {
    CloudOutline,
    DragOutline,
    HomeOutline,
    LockOutline,
    LogoutOutline,
    MenuOutline,
    MenuUnfoldOutline,
    MoonOutline,
    ProfileOutline,
    SettingOutline,
    UserOutline,
    DollarCircleOutline,
    SendOutline,
    SearchOutline,
    SyncOutline,
} from "@ant-design/icons-angular/icons";

export const icons = [
    MenuUnfoldOutline,
    MoonOutline,
    LogoutOutline,
    CloudOutline,
    HomeOutline,
    SettingOutline,
    LockOutline,
    ProfileOutline,
    UserOutline,
    MenuOutline,
    DragOutline,
    DollarCircleOutline,
    SendOutline,
    SearchOutline,
    SyncOutline,
];
